import './index.scss';
import { getVueI18n, translate } from 'shared/services/I18nService';
import { createToolbarButton } from 'uScope/js/components/toolbar-button/toolbar-button-factory';
import Vue from 'vue';
import { createId } from 'shared/util';
import api from 'uScope/js/public-api';
import PDN from './PinDropNavigator';
import { PdnStore } from 'vil/uScope-extensions/PinDropNavigator/PdnStore';

api.plugins.register({
  name: 'vil:pinDropNavigator',

  extends: 'uScope',

  canStart: function (uScope) {
    return uScope.toolbarCanAddButton('openPDNBtn');
  },

  constructor: function (uScope) {
    addToolbarButton(uScope);
    createPdnUi();
  }
});

function addToolbarButton (uScope) {
  const BUTTON_CLASS = 'vil-pdn-button';
  const BUTTON_HOVER_TEXT = translate('uScope.extensions.pindrop.toolbar-button-hover-text');
  const pdnButton = createToolbarButton({
    className: BUTTON_CLASS,
    title: BUTTON_HOVER_TEXT,
    onClick () {
      if (uScope.isThisImageValid()) {
        Vue.$store.dispatch('PDN_TOGGLE_NAVIGATOR');
      }
    }
  });
  uScope.topToolbar.addButton(pdnButton);
}

function createPdnUi () {
  const id = createId();
  const div = document.createElement('div');
  div.setAttribute('id', id);
  document.body.appendChild(div);

  Vue.$store.use(PdnStore);

  // eslint-disable-next-line no-new
  new Vue({
    el: `#${id}`,
    i18n: getVueI18n(),
    render: h => h(PDN),
    components: {PDN}
  });
}



// WEBPACK FOOTER //
// ./src/vil/uScope-extensions/PinDropNavigator/index.js